const ALLOWED_CREATIVE_TYPES = new Set(["image/svg+xml", "image/png"]);
const SVG_EXTENSION = ".svg";
const PNG_EXTENSION = ".png";

const hasExtension = (filename: string, extension: string) =>
  filename.toLowerCase().endsWith(extension);

export const getCreativeMediaType = (file: Pick<File, "name" | "type"> | null | undefined) => {
  if (!file) {
    return null;
  }

  const normalizedType = (file.type || "").toLowerCase();
  if (ALLOWED_CREATIVE_TYPES.has(normalizedType)) {
    return normalizedType;
  }

  const normalizedName = (file.name || "").toLowerCase();
  if (hasExtension(normalizedName, SVG_EXTENSION)) {
    return "image/svg+xml";
  }
  if (hasExtension(normalizedName, PNG_EXTENSION)) {
    return "image/png";
  }

  return null;
};

export const isSupportedCreativeFile = (file: Pick<File, "name" | "type"> | null | undefined) =>
  getCreativeMediaType(file) !== null;

